import React from 'react';
import cn from 'classnames';
import { ShipmentBundle } from 'api/optimalprint-sdk.d';
import formatPrice from 'utils/price/formatPrice';
import { useSelector } from 'react-redux';
import getPriceFormat from 'store/price/selector/getPriceFormat';
import getCurrencyId from 'store/price/selector/getCurrencyId';
import styles from './PriceValue.module.scss';

export interface OwnProps {
  price: ShipmentBundle.Entity.API.ShipmentPrice.ShipmentPriceListV2Response.IShipmentPrice;
  prefix?: string;
  theme?: string;
}

const PriceValue = ({ price, prefix, theme }: OwnProps) => {
  const currencyId = useSelector(getCurrencyId);
  const priceFormat = useSelector(getPriceFormat);

  if (!priceFormat || !currencyId) {
    return null;
  }
  return (
    <span className={cn(styles.price, styles[`theme-${theme}`])}>
      {prefix && <span>{prefix}</span>}
      <span
        className={cn({
          [styles.crossed]: price.pi !== price.p,
        })}
      >
        {formatPrice(price.pi, priceFormat, currencyId)}
      </span>
      {price.pi !== price.p ? (
        <span
          className={cn({
            [styles.red]: price.pi !== price.p,
          })}
        >
          {formatPrice(price.p, priceFormat, currencyId)}
        </span>
      ) : null}
    </span>
  );
};

export default PriceValue;
